// import CustomInputField from "@/components/form/CustomInputField";
import React, { useState } from "react";
import { PaymentMethod } from "./Earnings";
// import SingleSelector from "@/components/ui/SingleSelector";
import GlobalSelect from "@/components/ui/GlobalSelectItem";
import { CustomButton } from "@/components/ui/Buttons";
import { useConfirmation } from "@/context/ConfirmationContext/ConfirmationContext";
import toast from "react-hot-toast";
import { useGlobalContext } from "@/context/GlobalContext";
import InputField from "@/components/form/InputField";
import { useSubmitWithDrawReqMutation } from "@/redux/feature/balaneWithdraw/balaneWithdrawApi";
import { handleApiRequest } from "@/utils/handleApiRequest";

const WithdrawModal = ({
  paymentMethods,
  onClose,
  creatorId,
}: {
  paymentMethods: PaymentMethod[];
  onClose: () => void;
  creatorId: string;
}) => {
  const { userData, ucdT } = useGlobalContext();

  const [isLoading, setIsLoading] = useState(false);
  const requestConfirmation = useConfirmation();
  const [amount, setAmount] = useState(0);

  const [selectedMethod, setSelectedMethod] = useState<{
    id: string;
    title: string;
  } | null>(null);

  const paymentMethodOptions = paymentMethods.map((item) => {
    return {
      id: item._id,
      title: item.label,
    };
  });

  const [withDraw] = useSubmitWithDrawReqMutation();
  const handleSubmit = async () => {
    if (amount === 0) {
      toast.error("Please add some amount");
      return;
    }
    if (!selectedMethod) {
      toast.error("Please select an method");
      return;
    }
    const confirmed = await requestConfirmation(
      `Are you sure you want to withdraw ${amount}${ucdT.currency} into ${selectedMethod.title} ?`
    );

    if (!confirmed) {
      return;
    }

    const payload = {
      creator_id: creatorId,
      email: userData.email,
      withDrawMethod_id: selectedMethod?.id,
      amount: amount,
      currency: ucdT?.currency,
    };
    await handleApiRequest({
      payload: payload,
      requestFunction: withDraw,
      onSuccess: (res) => {
        console.log(res);
        toast.success("Submitted");
        onClose();
      },
      onError: (err) => {
        toast.error(err?.data?.message || "Some thing went wrong");
        console.log(err);
      },
    });
  };

  return (
    <div>
      <h2 className="text-xl font-medium">Withdraw Balance</h2>

      <div className="py-4 space-y-5">
        <InputField
          onChange={(e: any) => setAmount(e.target.value)}
          value={amount}
          label="Amount"
          name="amount"
          type="number"
        />

        <GlobalSelect
          selectedOption={selectedMethod}
          onSelect={(value) => setSelectedMethod(value)}
          label="Payment Method"
          showOtherInputField={false}
          options={paymentMethodOptions}
        />
      </div>

      <div className="flex mt-8  w-full justify-center gap-x-4">
        <CustomButton
          onClick={onClose}
          fontSize="14px"
          fontWeight="600"
          padding="8px 16px"
          color="#D92D20"
          border="1px solid #D92D20"
          variant="outline"
          className="w-full"
        >
          Cancel
        </CustomButton>
        <CustomButton
          onClick={handleSubmit}
          backgroundColor="#17457D"
          variant="default"
          //   border="1px solid #1D7100"
          fontSize="14px"
          fontWeight="600"
          disabled={isLoading}
          padding="8px 16px"
          className="w-full text-white"
        >
          {isLoading ? "Loading..." : "Submit"}
        </CustomButton>
      </div>
    </div>
  );
};

export default WithdrawModal;
